import styled from 'styled-components';

import 'antd/lib/spin/style/index.css';
import 'antd/lib/grid/style/index.css';

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 11px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  p {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: 0.01px;
    text-align: left;
    color: #707070;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #cc0000;
  }
  div.headerButtons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    button {
      padding: 0 20px;
      height: 34px;
      border-radius: 3.5px;
      background-color: #1a5f70;
      border: none;
      color: #fff;
      margin-left: 15px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      svg {
        margin-right: 4px;
      }

      &:first-child {
        background-color: #cc0000;
      }
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 10px;
  height: 30px;

  svg {
    color: #dddbdb;
  }

  span {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.02px;
    color: #cc0000;
  }
`;

export const BoxList = styled.div`
  width: '100%';
  height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 15px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #235f6e;

  div.boxFirst {
    padding-left: 15px;
    letter-spacing: 0px;
    text-align: left;
    color: #707070;
    display: flex;
    align-items: center;
    height: 70px;
    word-wrap: break-word;
  }

  div.boxInner {
    letter-spacing: 0px;
    padding-left: 2px;
    padding-right: 3px;
    text-align: left;
    color: #707070;
    display: flex;
    align-items: center;
    height: 70px;

    span {
      font-size: 13px;
      word-break: break-all;
    }
  }
`;

export const BoxTitleAlert = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 50px;
  img {
    width: 45px;
    height: 42px;
  }
  h2 {
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #cc0000;
    margin: 15px 0;
  }
  div.alertBox {
    width: 647.1px;
    padding: 20px;
    border-radius: 3px;
    border: solid 0.5px #cf0000;
    background-color: #f4d4d4;
    p {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      text-align: center;
      color: #d20000;
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const BoxButtonDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
`;
